import { userRepositoryImplementation } from '@shared/infrastructure/http/repositories/users/userRepositoryImplementation';

export const userRepository = {
  getUsers: () => {
    return userRepositoryImplementation.getUsers();
  }
};
